/**
 * AWS Bedrock Model IDs
 * Use these constants instead of hardcoded strings throughout the frontend
 *
 * Note: These should match the backend constants in app/constants/bedrock-pricing.ts
 */
export const BEDROCK_MODEL_IDS = {
  CLAUDE_3_5_SONNET_V2: 'us.anthropic.claude-3-5-sonnet-20241022-v2:0',
  CLAUDE_3_HAIKU: 'us.anthropic.claude-3-haiku-20240307-v1:0',
} as const

export type BedrockModelId = typeof BEDROCK_MODEL_IDS[keyof typeof BEDROCK_MODEL_IDS]
